import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentListStateService } from 'src/app/content-list-management/shared/services/cmsapi/content-list-state.service';

type WithNameFormSectionType = {
  _initName(name: string): void;
  _initNameValueChanges(getPreviousName: () => string | null): void;
  _buildName(): string;
};

type NameFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { NAME: () => string };
  destroy$: Subject<boolean>;
  contentListStateService: ContentListStateService;
};

export function WithNameFormSection<
  TBase extends Constructor<NameFormSectionRequerimentsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithNameFormSectionType;
  prototype: WithNameFormSectionType;
} & TBase {
  return class WithNameFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initName(name: string): void {
      this.form.get(this.FORM_PATHS.NAME()).setValue(name);
    }

    _initNameValueChanges(getPreviousName: () => string | null): void {
      this.form
        .get(this.FORM_PATHS.NAME())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            this.contentListStateService.changeContentList(true);
            if (newValue === getPreviousName()) {
              this.form.get(this.FORM_PATHS.NAME()).markAsPristine();
            }
          },
        });
    }

    _buildName(): string {
      return this.form.get(this.FORM_PATHS.NAME()).value;
    }
  };
}
